import { Routes } from '@angular/router';
import { APP_PAGES } from '@core/constants/app-pages.const';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { permissionGuard } from '@core/guards/permission.guard';

export const routes: Routes = [
  {
    path: APP_PAGES.LOGIN.path,
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: APP_PAGES.FORGOT_PASSWORD.path,
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: APP_PAGES.ROOT.path,
    canActivate: [authGuard],
    loadComponent: () => import('./shared/components/layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      {
        path: APP_PAGES.ROOT.path,
        canActivate: [permissionGuard(APP_PAGES.ROOT.permission)],
        loadComponent: () => import('./features/auth/landing/landing.component').then((m) => m.LandingComponent),
        pathMatch: 'full',
      },
      {
        path: APP_PAGES.DASHBOARD.path,
        canActivate: [permissionGuard(APP_PAGES.DASHBOARD.permission)],
        loadComponent: () =>
          import('./features/dashboard/dashboard-container/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: APP_PAGES.ACCESS_POINTS.path,
        canActivate: [permissionGuard(APP_PAGES.ACCESS_POINTS.permission)],
        loadComponent: () =>
          import('./features/access-points/access-points-container/access-points.component').then(
            (m) => m.AccessPointsComponent,
          ),
      },
      {
        path: APP_PAGES.USERS.path,
        canActivate: [permissionGuard(APP_PAGES.USERS.permission)],
        loadChildren: () => import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: APP_PAGES.POLICIES.path,
        canActivate: [permissionGuard(APP_PAGES.POLICIES.permission)],
        loadChildren: () => import('./features/policies/policies.routes').then((m) => m.POLICIES_ROUTES),
      },
      {
        path: APP_PAGES.STAFF.path,
        canActivate: [permissionGuard(APP_PAGES.STAFF.permission)],
        loadChildren: () => import('./features/staff/staff.routes').then((m) => m.STAFF_ROUTES),
      },
      {
        path: APP_PAGES.REPORTS.path,
        canActivate: [permissionGuard(APP_PAGES.REPORTS.permission)],
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: APP_PAGES.INFRASTRUCTURE.path,
        canActivate: [permissionGuard(APP_PAGES.INFRASTRUCTURE.permission)],
        loadChildren: () =>
          import('./features/infrastructure/infrastructure.routes').then((m) => m.INFRASTRUCTURE_ROUTES),
      },
      {
        path: APP_PAGES.SETTINGS.path,
        canActivate: [permissionGuard(APP_PAGES.SETTINGS.permission)],
        loadChildren: () => import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
    ],
  },
  {
    path: APP_PAGES.FORBIDDEN.path,
    loadComponent: () => import('./shared/components/error-403/error-403.component').then((m) => m.Error403Component),
  },
  {
    path: '**',
    redirectTo: APP_PAGES.ROOT.path,
  },
];
